// src/pages/xray/XrayLobby/TabPacketsDropped.js
import React from 'react';

const TabPacketsDropped = ({
  selectedTabsPackets,
  setSelectedTabsPackets,
  packetsDropped,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['DROPPED PACKETS'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsPackets === `tabsPackets${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedTabsPackets === `tabsPackets${index + 1}`}
              onChange={() => setSelectedTabsPackets(`tabsPackets${index + 1}`)}
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsPackets === 'tabsPackets1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">
              VLAN SUBINTERFACES ETH0.XXX - DROPPED PACKETS
            </h1>
            <div>
              {packetsDropped &&
                packetsDropped.split('\n').map((line, idx) => {
                  const highlightedLine = line.replace(
                    /(dropped:)(\d+)/g,
                    (match, label, value) => {
                      if (parseInt(value) !== 0) {
                        return `${label}<span class="bg-red-200 text-red-800 font-bold px-1 rounded">${value}</span>`;
                      }
                      return match;
                    }
                  );
                  return (
                    <div
                      key={idx}
                      dangerouslySetInnerHTML={{ __html: highlightedLine }}
                      style={{ whiteSpace: 'pre' }}
                    />
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TabPacketsDropped;
